import type { ReportDocument, ReportEntryDocument } from "./types";
import CashStatementTemplate from "./CashStatementTemplate";
import GenericGenevaReportTemplate from "./GenericGenevaReportTemplate";
import RealizedProfitLossTemplate from "./RealizedProfitLossTemplate";

type RenderGenevaReportTemplateProps = {
  report: ReportDocument;
  entries: ReportEntryDocument[];
};

export function renderGenevaReportTemplate({
  report,
  entries,
}: RenderGenevaReportTemplateProps) {
  if (report.reportName === "cashtran_ssrs") {
    return <CashStatementTemplate report={report} entries={entries} />;
  }

  if (report.reportName?.toLowerCase().includes("glmap_realizedgl")) {
    return <RealizedProfitLossTemplate report={report} entries={entries} />;
  }

  return <GenericGenevaReportTemplate report={report} entries={entries} />;
}
